import React from 'react';
import { CardTitle } from '@udemy/react-product-card-components';

/**
 * Props for the `CourseCardTitleWithAnchor` component.
 */

/**
 * ### CourseCardTitleWithAnchor
 *
 * @remarks
 *
 * Renders a `CardTitle` with an anchor tag from a `Course` object.
 *
 * @see {@link @udemy/react-product-card-components#CardTitle}
 */
export const CourseCardTitleWithAnchor = ({
  course,
  headingLevel,
  ...anchorProps
}) => {
  const render = CardTitle.renderAnchorTag(anchorProps);
  return /*#__PURE__*/React.createElement(CardTitle, {
    headingLevel: headingLevel,
    renderLink: render
  }, course.title);
};
//# sourceMappingURL=course-card-title-with-anchor.react-component.js.map